<template>
  <Card class="card p-4 h-100">
    <div class="row">
      <div class="col-10">
        <Input
            inputClass="form-control form-control-sm"
            name="input-search"
            :isInputGroup="true"
            :placeholder="$t('label.search')"
            v-model="query.search"
        >
          <template #rightAddon>
            <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle me-3">
              <i class="fa fa-search"></i>
            </span>
          </template>
        </Input>
      </div>
      <div class="col-2 justify-content-center align-items-center mt-2 mb-5">
        <button data-kt-menu-trigger="hover" data-kt-menu-placement="bottom-start" class="btn btn-primary btn-icon">
          <i class="bi bi-plus fs-2"></i>
        </button>
        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-175px py-4" data-kt-menu="true">
          <div class="menu-item px-3">
            <a href="#" data-bs-target="#create_direct_discussion" data-bs-toggle="modal" class="menu-link px-3">
              <span class="">
                <span class="me-4 fs-3"><i class="fa fa-user"></i></span>
                <span>Discussion directe</span>
              </span>
            </a>
          </div>

          <div class="menu-item  px-3">
            <a href="#" data-bs-target="#create_group_discussion" data-bs-toggle="modal" class="menu-link px-3">
              <span class="">
                <span class="me-4 fs-3"><i class="fa fa-users"></i></span>
                <span>Discussion de groupe</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column mt-5 h-80 scroll-y position-relative">
      <div class="position-absolute end-50 bg-white opacity-5" v-if="loading">
        <div class="d-flex justify-content-center align-items-center">
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">{{ $t("loadingText") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!sortedSearchedConversations.length && !loading" class="d-flex justify-content-center align-items-center">
        <div class="mb-10 mt-20 text-center">
          <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
            Aucune discussion trouvée
          </div>
        </div>
      </div>
      <div
          class="col-12 p-2 cursor-pointer"
          v-for="(discussion, index) in sortedSearchedConversations"
          :key="index"
          @click.prevent="() => toggleConversation(discussion.id)"
      >
        <DiscussionCard :discussion="discussion" />
      </div>
    </div>

    <create-discussion id="create_direct_discussion" :module-id="moduleId" :module-class="moduleClass" />
    <create-group-discussion id="create_group_discussion" :module-id="moduleId" :module-class="moduleClass" />
  </Card>
</template>

<script setup>

import Card from "@/components/Card.vue";
import Input from "@/components/Input.vue";
import DiscussionCard from "@/Modules/Chat/components/DiscussionCard.vue";
import CreateDiscussion from "@/Modules/Chat/components/modals/CreateConversationModal.vue";
import CreateGroupDiscussion from "@/Modules/Chat/components/modals/CreateGroupConversationModal.vue";
import Button from "@/components/Button.vue";

import {defineProps, computed} from "vue";
import {useStore} from "vuex";

const store = useStore()
const emits = defineEmits(['toggleConversation'])
const props = defineProps({
  query: {
    type: Object,
    default: () => ({
      search: '',
      type: 'all'
    })
  },
  moduleId: { type: String, default: '' },
  moduleClass: { type: String, default: '' },
  loading: { type: Boolean, default: false },
})

const conversations = computed(() => store.getters['chat/getConversations'])

const searchedConversations = computed(() => {
  if(props.query.type === 'all') {
    return Object.values(conversations.value).filter((c) => c.name?.toLocaleLowerCase()?.includes(props.query.search.toLocaleLowerCase()))
  }

  if(props.query.type === 'canal') {
    return Object.values(conversations.value).filter((c) => c.is_group === true && c.name?.toLocaleLowerCase()?.includes(props.query.search.toLocaleLowerCase()))
  }

  if(props.query.type === 'disc') {
    return Object.values(conversations.value).filter((c) => c.is_group === false && c.name?.toLocaleLowerCase()?.includes(props.query.search.toLocaleLowerCase()))
  }

  return ''
})

const sortedSearchedConversations = computed(() =>
    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    searchedConversations.value.sort((a, b) => new Date(b.last_update).getTime() - new Date(a.last_update).getTime())
)

function toggleConversation(conversationId) {
  emits('toggleConversation', conversationId)
}



</script>

<style scoped>

</style>